import { makeStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { DateIcon } from '../../../../components/Icon';
import { classNames } from '../../../../utils';

const useStyles = makeStyles((theme) => ({
  date: ({ width, color, m }) => ({
    width,
    '& .MuiInputBase-root': {
      borderRadius: '0.5rem',
      backgroundColor: theme.palette.font.white,
      borderColor: '#e4e7eb',
      paddingLeft: '0.3rem',
      margin: m,
    },
    '& .MuiInputBase-input': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '0.919rem',
      letterSpacing: '0',
      color: color ?? theme.palette.font.main,
      fontWeight: '500',
      width: '6rem',
      paddingRight: '0',
    },
    '& .MuiIconButton-root': {
      padding: '10px',
    },
  }),
  dateIcon: {
    color: theme.palette.primary.main,
  },
}));

export default function DatePicker({
  selectDate,
  handleSelectDate,
  className,
  width,
  color,
  id = '3',
  placeholder,
  allowNull = false,
  m = '0 1.25rem 0 0',
  minDate = moment('1976-01-01', 'YYYY-MM-DD'),
  maxDate = moment('9999-12-31', 'YYYY-MM-DD'),
  ...rest
}) {
  const classes = useStyles({ width, color, m });
  const handleOnChange = (props) => {
    if (!allowNull) {
      if (!props || (props['_i'] && props['_i'][9] === '_')) {
        return;
      }
      handleSelectDate(props);
    } else {
      if (!moment(props).isValid() && props !== null) {
        return;
      }
      handleSelectDate(props);
    }
  };

  return (
    <KeyboardDatePicker
      autoOk
      id={id}
      className={className ? classNames(classes.date, className) : classes.date}
      size="small"
      onChange={handleOnChange}
      keyboardIcon={<DateIcon className={classes.dateIcon} />}
      value={selectDate}
      variant="inline"
      format="DD-MM-yyyy"
      inputVariant="outlined"
      InputAdornmentProps={{ position: 'start' }}
      placeholder={placeholder ?? 'Today'}
      maxDate={maxDate}
      minDate={minDate}
      {...rest}
    />
  );
}
